export default {
  isLocal: true,

  GRID_WIDTH: 6,
  GRID_HEIGHT: 5,
  GRID_TOTAL: 6 * 5,

  HOST: "",
  locale: "en",
  pattern: null,
  app: null,
  reelsObject:null,

  fonts: [
    "Roboto",
    "Noto Serif",
  ],

  // todo change
  assetsPath: "./assets/json/AssetsConfig.json",
  fontsPath: "./assets/font/fonts.css",

  TO_FIXED_VALUES: 2,
  MIN_COUNTUP_WIN: 2,
  TIME_UPDATE_BALANCE: 15000,

  anticipation: {
    inFreespinsMode: true,
    countAnticipationMin: 1,
  },

  SYMBOL_ANIMATION_DURATION: 1633,

  LANDINGS: {
    Scatter: "ScatterLanding",
  },

  LANDINGS_ANTICIPATION: {
    Scatter: {
      anticipateIn: "ScatterAnticipateIn",
      anticipateLoop: "ScatterAnticipateLoop",
      anticipateOut: "ScatterAnticipateOut",
    },
  },

  shouldAccelerate: false,

  //symbolIndexes: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"],

  symbolIndexes: [
    "14001",
    "14002",
    "14003",
    "14004",
    "14005",
    "14006",
    "14007",
    "14008",
    "14009",
    "14010",
    "14011",
  ],

  symbolsNames: {
    14001: "dragon_fruit",
    14002: "papaya",
    14003: "watermelon",
    14004: "coconut",
    14005: "strawberry",
    14006: "orange",
    14007: "banana",
    14008: "grapes",
    14009: "cherry",
    14010: "tiki_mask",
    14011: "fishBowl",
  },

  symbolsPosition: {
    4002: { x: 0, y: 0 },
  },

  symbolAnimationNames: {
    14001: "dragon_fruit",
    14002: "papaya",
    14003: "watermelon",
    14004: "coconut",
    14005: "strawberry",
    14006: "orange",
    14007: "banana",
    14008: "grapes",
    14009: "cherry",
    14010: "tiki_mask",
    14011: "fishBowl",
  },

  symbolsSpines: {
    14001: "dragon_fruit",
    14002: "papaya",
    14003: "watermelon",
    14004: "coconut",
    14005: "strawberry",
    14006: "orange",
    14007: "banana",
    14008: "grapes",
    14009: "cherry",
    14010: "tiki_mask",
    14011: "fishBowl",
  },

  multiplierSymbol: "14011",
  scatterSymbol: "14010",

  animationList: [
    "cherry",
    "orange",
    "dragon_fruit",
    "strawberry",
    "watermelon",
    "papaya",
    "grapes",
    "tiki_mask",
    "coconut",
    "banana",
    "fishBowl",
  ],

  stickyWildSymbol: { code: "4001", animation: "WildSticky" },

  multiplier: { list: ["bonus/x2", "bonus/x3"], position: { x: 95, y: 25 } },

  anticipationSymbols: ["4002"],

  upperSymbols: ["4002"],

  allowReelsToAnticipate: [0, 0, 0, 0, 0, 1], // 0: isnt allowed; 1: is allowed

  SPECIAL_WINS: [
    {
      name: "big",
      from: 15,
      to: 49.99,
      time: 5,
    },
    {
      name: "great",
      from: 50,
      to: 99.99,
      time: 8,
    },
    {
      name: "huge",
      from: 100,
      to: 499.99,
      time: 12,
    },
    {
      name: "massive",
      from: 500,
      to: 999.99,
      time: 16,
    },
    {
      name: "jackpot",
      from: 1000,
      to: 9999999999,
      time: 28,
    },
  ],
  bigwinStatePrefix: ["big", "great", "huge", "massive", "jackpot"],
  bigwinStateSuffix: ["_win_start", "_win_idle"],
  autoSingleWinValues: ["-", "x3", "x5", "x10", "x20", "x50", "x100"],
  autoIncreasesValues: ["-", "x5", "x10", "x15", "x20", "x25", "x50", "x100"],
  autoDecreasesValues: ["-", "x5", "x10", "x15", "x20", "x25", "x50", "x100"],
  setAutospinValues: [5, 10, 20, 50, 100, 500, 400, -1],
  autoStopBalanceLowerValues: [0, 0.5, 0.75],
  autoStopBalanceHigherValues: [1.5, 2, 5],

  realitiCheckPopup: {
    status: 911,
    message:
      "You have been playing for <session_hours_played> hours and <session_minutes_played> minutes. In total, you have bet <session_total_bet> and won <session_total_win>. Would you like to keep playing?",
    title: "REALITY CHECK",
    buttons: [
      {
        text: "KEEP PLAYING",
        action: "continue",
      },
      {
        text: "QUIT THE GAME",
        action: "lobby",
      },
    ],
  },

  sizes: {
    desktop: {
      total: {
        width: 2778, //2570,
        height: 2778,
      },
      safe: {
        width: 1990, //2020,//1990,
        height: 1380, //1280//1380
      },
    },
    mobilePortrait: {
      total: {
        width: 2778, //2778
        height: 2778,
      },
      safe: {
        width: 1080,
        height: 1200,
      },
    },
    mobileLandscape: {
      total: {
        width: 2778,
        height: 2600,
      },
      safe: {
        width: 2150,
        height: 1280,
      },
    },
  },
};
